export function getShopSlug() {
  // 1) QR entry 페이지면 이게 가장 정확
  if (window.QRSHOP?.shop) return String(window.QRSHOP.shop);

  // 2) /mono/... 에서 mono
  const seg = location.pathname.split('/').filter(Boolean)[0];
  if (seg && seg !== 'qr') return seg; // /qr/ 같은 경우 방지

  // 3) ?shop=mono
  const q = new URLSearchParams(location.search);
  const shop = q.get('shop');
  if (shop) return shop;

  // 4) fallback (정책)
  return 'mono'; // 또는 'global'
}

export function getPrefix() {
  if (window.QRSHOP?.prefix) return String(window.QRSHOP.prefix);
  const version = 'v1';
  const shop = getShopSlug();
  return `qrshop:${version}:${shop}:`;
}
